{
  "name": "e-inv-app",
  "version": "1.0.33",
  "description": "E-Invitation Web Application",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "vite build && node scripts/generate-meta-pages.mjs",
    "build:meta": "node scripts/generate-meta-pages.mjs",
    "preview": "vite preview",
    "lint": "eslint src --ext js,jsx"
  },
  "dependencies": {
    "canvas-confetti": "^1.9.4",
    "clsx": "^2.1.1",
    "framer-motion": "^12.29.0",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "react-icons": "^5.5.0",
    "react-lazy-load-image-component": "^1.6.3",
    "react-pageflip": "^2.0.3",
    "react-router-dom": "^6.22.0",
    "tailwind-merge": "^3.4.0"
  },
  "devDependencies": {
    "@types/react": "^18.2.48",
    "@types/react-dom": "^18.2.18",
    "@vitejs/plugin-react": "^6.0.1",
    "eslint": "^8.56.0",
    "eslint-plugin-react": "^7.33.2",
    "eslint-plugin-react-hooks": "^4.6.0",
    "shadcn": "^3.7.0",
    "sharp": "^0.34.5",
    "svgo": "^4.0.1",
    "terser": "^5.46.0",
    "vite": "^8.0.10",
    "vite-plugin-image-optimizer": "^2.0.3"
  }
}
